import { RemittanceListUrlFilters } from "@saleor/remittance/url";
import Moment from "moment";

import { getGteLteVariables } from "../../../utils/filters";

export function getFilterVariables(params: RemittanceListUrlFilters) {
  const startDate = Moment.tz(
    `${params.orderDate} 00:00:00`,
    "Asia/Manila"
  ).format("YYYY-MM-DD HH:mm:ssZZ");

  const endDate = Moment.tz(`${params.orderDate} 00:00:00`, "Asia/Manila")
    .add(1, "days")
    .format("YYYY-MM-DD HH:mm:ssZZ");

  return {
    completedAt: getGteLteVariables({
      gte: startDate || null,
      lte: endDate || null
    })
  };
}
